import React from 'react';
import { AlertTriangle, RotateCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Local React ErrorBoundary that prevents a render crash from blanking out
 * the whole app. Shows a friendly fallback + a "Recharger" button.
 */
export default class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[PageErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-white rounded-2xl border border-red-200 p-6 max-w-2xl mx-auto mt-8" data-testid="page-error-boundary">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-6 h-6 text-red-600 shrink-0 mt-0.5" />
            <div className="flex-1">
              <h2 className="text-base font-semibold text-slate-900">
                Un imprévu s'est produit sur cette page
              </h2>
              <p className="text-sm text-slate-600 mt-1">
                Vos données ne sont pas perdues — le serveur est toujours en ligne.
                Rafraîchissez la page pour revenir à un état stable.
              </p>
              <pre className="mt-3 bg-slate-50 border border-slate-200 rounded p-2 text-xs text-slate-600 max-h-32 overflow-auto whitespace-pre-wrap">
                {String(this.state.error?.message || this.state.error || 'Erreur inconnue')}
              </pre>
              <div className="flex items-center gap-2 mt-4">
                <Button onClick={() => window.location.reload()} data-testid="error-reload-btn">
                  <RotateCw className="w-4 h-4 mr-1.5" /> Recharger la page
                </Button>
                <Button variant="outline" onClick={() => window.history.back()}>
                  Retour
                </Button>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
